module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/1-3a5b31b66b49bc64c83e97754041c030.png";